const generateUrl = (imgconfig, image) => {
  const imageHost = 'https://http2.mlstatic.com/';
  const format = 'jpg';

  return `${imageHost}${imgconfig.prefix}${image}-${imgconfig.size}.${format}`;
};

module.exports = { generateUrl };
